module.exports = __webpack_public_path__ + "static/media/play.1625a0e3.svg";